import TextLevelerView from "@features/tools/view/text-leveler-view";

const TextLeveler = () => {
  return <TextLevelerView />;
};

export default TextLeveler;
